import moment from 'moment-timezone';

import { Comment } from '@models/conversational/comment.model';
import { Thread } from '@models/conversational/thread.model';

import { ApiAdapter } from './adapter';
import { FileLinkAdapter } from './file-link.adapter';
import { UserAdapter } from './user.adapter';

export class ThreadCommentAdapter extends ApiAdapter<Comment> {
  private userAdapter = new UserAdapter();
  private fileLinkAdapter = new FileLinkAdapter();

  get(json, thread?: Thread): Comment {
    return new Comment({
      id: json['id'],
      parent: thread,
      author: this.userAdapter.get(json['created_by']),
      createdAt: moment.tz(json['creation_date'], moment.tz.guess()),
      body: json['body'],
      links: this.fileLinkAdapter.list(json['files']),
      users: this.userAdapter.list(json['contacts']),
    });
  }
}
